const SYSTEM_FONTS = new Set([
  'system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica',
  'Arial', 'sans-serif', 'serif', 'monospace', 'ui-monospace', 'ui-sans-serif',
]);
const loaded = new Set<string>();

function primaryFamily(stack: string): string | null {
  const first = stack.split(',')[0].trim().replace(/^["']|["']$/g, '');
  return !first || SYSTEM_FONTS.has(first) ? null : first;
}

export function loadGoogleFont(stack: string): void {
  const name = primaryFamily(stack);
  if (!name || loaded.has(name)) return;
  const id = `gfont-${name.replace(/\s+/g, '-').toLowerCase()}`;
  loaded.add(name);
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name)}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}
